import { render, staticRenderFns } from "./StandardRuleModal.vue?vue&type=template&id=33232797&scoped=true&"
import script from "./StandardRuleModal.vue?vue&type=script&lang=js&"
export * from "./StandardRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./StandardRuleModal.vue?vue&type=style&index=0&id=33232797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33232797",
  null
  
)

export default component.exports